import React from 'react';
import { Link } from 'react-router-dom';
import type { AssignmentActivity as AssignmentActivityType } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { AppRoutes, ActivityTypes } from 'types';
import ActivityIcon from './Activityicon';
import { ASSIGNMENT_STATUSES, AssignmentWithCover } from '../types';
import { isCompletedStatus } from '../util';

type AssignmentActivityProps = {
  assignment: AssignmentWithCover;
  assignmentActivity: AssignmentActivityType;
  assignmentId: number;
  status: ASSIGNMENT_STATUSES;
};

const AssignmentActivity: React.FC<AssignmentActivityProps> = ({
  assignment,
  assignmentActivity,
  assignmentId,
  status,
}) => {
  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      {isCompletedStatus(status) &&
      assignmentActivity?.activity?.activityType?.name !== ActivityTypes.PRACTICE_BOOK ? (
        <ActivityIcon
          assignment={assignment}
          assignmentActivity={assignmentActivity}
          status={status}
        />
      ) : (
        <Link
          to={{
            pathname: `/${AppRoutes.ASSIGNMENT_ACTIVITIES}/${assignmentActivity.id}`,
            search: `?assignmentId=${assignmentId}&activity=${assignmentActivity?.activity?.activityType?.name}&bookCode=${assignment?.cover?.routeParam}`,
          }}
        >
          <ActivityIcon
            assignment={assignment}
            assignmentActivity={assignmentActivity}
            status={status}
          />
        </Link>
      )}
    </div>
  );
};

export default AssignmentActivity;
